import React from 'react'
import { Image } from '@/atoms/Image'
import { FranchisePageData } from '@/services/FranchiseService'
import { useSafeTrack } from '@/utils/analytics'

export interface FranchisePosterProps {
  pageData?: FranchisePageData | null
}

export const FranchisePoster: React.FC<FranchisePosterProps> = ({ pageData }) => {
  const track = useSafeTrack()
  const desktopPosterUrl = pageData?.posterDesktop?.item?.[0]?.secure_url ?? pageData?.posterDesktop?.item?.[0]?.url
  const tabletPosterUrl =
    pageData?.posterTablet?.item?.[0]?.secure_url ??
    pageData?.posterTablet?.item?.[0]?.url ??
    pageData?.posterDesktop?.item?.[0]?.secure_url ??
    pageData?.posterDesktop?.item?.[0]?.url ??
    null
  const mobilePosterUrl =
    pageData?.posterMobile?.item?.[0]?.secure_url ??
    pageData?.posterMobile?.item?.[0]?.url ??
    pageData?.posterTablet?.item?.[0]?.secure_url ??
    pageData?.posterTablet?.item?.[0]?.url ??
    pageData?.posterDesktop?.item?.[0]?.secure_url ??
    pageData?.posterDesktop?.item?.[0]?.url ??
    null
  const posterHref = pageData?.posterHref

  if (!desktopPosterUrl && !posterHref) {
    return null
  }

  const handleClick = () => {
    track('Clicked Franchise Page Poster', {
      franchiseSlug: pageData?.slug,
    })
  }

  return (
    <section id="hero" className="relative my-10 h-full w-full max-w-[1680px] px-4 md:px-8 lg:px-16 3lg:mx-auto">
      <a className="relative h-full w-full cursor-pointer bg-cover" href={posterHref ?? ''} onClick={handleClick}>
        {desktopPosterUrl && (
          <Image
            className="hidden h-full w-full rounded-2xl lg:flex"
            src={desktopPosterUrl}
            alt="Franchise poster"
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
          />
        )}
        {tabletPosterUrl && (
          <Image
            className="hidden h-full w-full rounded-2xl md:flex lg:hidden"
            src={tabletPosterUrl}
            alt="Franchise poster"
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
          />
        )}
        {mobilePosterUrl && (
          <Image
            className="flex h-full w-full rounded-2xl md:hidden"
            src={mobilePosterUrl}
            alt="Franchise poster"
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
          />
        )}
      </a>
    </section>
  )
}
